module.exports = __webpack_public_path__ + "img/product-preview-7.8a052c5.png";